<template>
  <div>
    <v-dialog v-bind:fullscreen="$vuetify.breakpoint.mdAndDown" scrollable
              v-bind:value="value"
              v-on:input="$emit('input', $event)"
              width="600">
      <v-card>
        <dialog-header v-bind:close-label="$t('close')"
                       v-bind:image-src="foodTruck.imageId != null ? attachmentUrl(foodTruck.imageId) : defaultImageUrl"
                       v-bind:title="foodTruck.title"
                       v-on:close="$emit('input', false)">
          <v-avatar size="64"
                    slot="avatar"
                    v-bind:color="foodTruck.logoId == null ? 'accent' : 'white'">
            <v-img v-bind:src="attachmentUrl(foodTruck.logoId)"
                   v-if="foodTruck.logoId != null" />
            <v-icon dark
                    v-else>
              mdi-truck
            </v-icon>
          </v-avatar>
          <template slot="subtitle">
            <span>
              <v-icon class="mr-1"
                      dark
                      x-small>
                {{ `mdi-${categoryIcon(foodTruck.categoryId)}` }}
              </v-icon>
              {{ categoryTitle(foodTruck.categoryId) }}
            </span>

            <span class="ml-2"
                  v-if="foodTruck.secondaryCategoryId != null">
              <v-icon class="mr-1"
                      dark
                      x-small>
                {{ `mdi-${categoryIcon(foodTruck.secondaryCategoryId)}` }}
              </v-icon>
              {{ categoryTitle(foodTruck.secondaryCategoryId) }}
            </span>
          </template>
        </dialog-header>

        <v-tabs class="flex-grow-0"
                color="accent"
                grow
                v-if="!foodTruck.partner"
                v-model="tab">
          <v-tab href="#details">
            <v-icon left
                    small>
              mdi-information-outline
            </v-icon>
            {{ $t('details' )}}
          </v-tab>
          <v-tab href="#hours">
            <v-icon left
                    small>
              mdi-clock-outline
            </v-icon>
            {{ $t('hours') }}
          </v-tab>
        </v-tabs>
        <v-divider />

        <v-card-text class="pa-0">
          <v-tabs-items v-model="tab">
            <v-tab-item value="details">
              <!-- DETAILS -->
              <!-- ------- -->
              <div class="black--text px-4 pt-4"
                   v-if="todaysSlots.length !== 0">
                <v-row dense>
                  <v-col cols="12"
                         sm="6"
                         v-bind:key="slot.id"
                         v-for="slot in todaysSlots">
                    <v-card outlined
                            rounded="lg">
                      <v-card-text class="align-center d-flex">
                        <div class="flex-grow-1">
                          <p class="accent--text font-weight-bold mb-1 text-subtitle-1">
                            {{ slotDateLabel }} · {{ slot.from }}–{{ slot.to }}
                          </p>
                          <p class="black--text mb-0">
                            {{ slot.streetAddress }}<br>
                            {{ slot.postalCode }} {{ slot.city }}<br>
                            {{ slot.country }}
                          </p>
                        </div>
                        <v-btn color="accent"
                               icon
                               v-bind:aria-label="$t('route')"
                               v-bind:href="mapUrl(slot)">
                          <v-icon>mdi-directions</v-icon>
                        </v-btn>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <div class="d-flex flex-wrap px-2 pt-3">
                <quick-action icon="mdi-phone"
                              v-bind:href="`tel:${foodTruck.phone}`"
                              v-bind:label="$t('order')"
                              v-if="foodTruck.phone != null && foodTruck.phone.length !== 0" />
                <quick-action icon="mdi-email-outline"
                              v-bind:href="`mailto:${email}`"
                              v-bind:label="foodTruck.partner ? $t('contact') : $t('catering')"
                              v-if="email != null && email.length !== 0" />
                <quick-action icon="mdi-instagram"
                              target="_blank"
                              v-bind:href="foodTruck.instagram"
                              v-bind:label="$t('instagram')"
                              v-if="foodTruck.instagram != null && foodTruck.instagram.length !== 0" />
                <quick-action icon="mdi-share-variant-outline"
                              v-bind:label="$t('share')"
                              v-if="canShare"
                              v-on:click="share" />
              </div>

              <div class="black--text px-4 pt-4"
                          v-if="description != null && description.length !== 0">
                <p v-html="description"></p>
              </div>

              <div class="px-4 pt-2"
                   v-if="foodTruck.imageId != null || foodTruck.imageId2 != null || foodTruck.imageId3 != null || foodTruck.imageId4 != null">
                <v-row dense>
                  <v-col cols="6"
                         v-if="foodTruck.imageId != null">
                    <v-img aspect-ratio="1"
                           class="rounded-lg"
                           v-bind:src="attachmentUrl(foodTruck.imageId)" />
                  </v-col>
                  <v-col cols="6"
                         v-if="foodTruck.imageId2 != null">
                    <v-img aspect-ratio="1"
                           class="rounded-lg"
                           v-bind:src="attachmentUrl(foodTruck.imageId2)" />
                  </v-col>
                  <v-col cols="6"
                         v-if="foodTruck.imageId3 != null">
                    <v-img aspect-ratio="1"
                           class="rounded-lg"
                           v-bind:src="attachmentUrl(foodTruck.imageId3)" />
                  </v-col>
                  <v-col cols="6"
                         v-if="foodTruck.imageId4 != null">
                    <v-img aspect-ratio="1"
                           class="rounded-lg"
                           v-bind:src="attachmentUrl(foodTruck.imageId4)" />
                  </v-col>
                </v-row>
              </div>

              <v-list class="pt-2"
                      two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon color="accent">mdi-map-marker-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ `${foodTruck.streetAddress}, ${foodTruck.postalCode} ${foodTruck.city}` }}</v-list-item-title>
                    <v-list-item-subtitle>{{ $t('location') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="foodTruck.phone != null && foodTruck.phone.length !== 0">
                  <v-list-item-icon>
                    <v-icon color="accent">mdi-phone-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ foodTruck.phone }}</v-list-item-title>
                    <v-list-item-subtitle>{{ $t('phone') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="foodTruck.specialties != null && foodTruck.specialties.length !== 0">
                  <v-list-item-icon>
                    <v-icon color="accent">mdi-star-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="text-wrap">{{ foodTruck.specialties }}</v-list-item-title>
                    <v-list-item-subtitle>{{ $t('specialties') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <div class="pb-4 px-4">
                <v-btn block
                       class="mb-3"
                       color="accent"
                       large
                       outlined
                       rounded
                       target="_blank"
                       v-bind:href="attachmentUrl(foodTruck.menuId)"
                       v-if="foodTruck.menuId != null">
                  <v-icon left>mdi-food-drumstick-outline</v-icon>
                  {{ $t('showMenu') }}
                </v-btn>

                <v-btn block
                       class="mb-3"
                       color="accent"
                       large
                       outlined
                       rounded
                       target="_blank"
                       v-bind:href="foodTruck.shop"
                       v-if="!!foodTruck.partner && foodTruck.shop != null && foodTruck.shop.length !== 0">
                  <v-icon left>mdi-cart-outline</v-icon>
                  {{ $t('onlineShop') }}
                </v-btn>

                <v-btn block
                       color="accent"
                       depressed
                       large
                       rounded
                       target="_blank"
                       v-bind:href="foodTruck.web"
                       v-if="foodTruck.web != null && foodTruck.web.length !== 0">
                  <v-icon left>mdi-open-in-new</v-icon>
                  {{ $t('goToWebSite') }}
                </v-btn>
              </div>
            </v-tab-item>
            <v-tab-item value="hours">
              <!-- HOURS -->
              <!-- ----- -->
              <div class="pa-4">
                <v-select dense
                          hide-details="auto"
                          outlined
                          rounded
                          v-bind:items="weekItems"
                          v-model="selectedWeek" />
              </div>
              <v-divider />

              <div v-bind:class="{ 'black--text': true, 'hours-day': true, 'hours-day--selected': isSelectedDayOfWeek(dayOfWeekGroup.dayOfWeek) }"
                   v-bind:key="dayOfWeekGroup.dayOfWeek"
                   v-for="dayOfWeekGroup in timeSlotGroups">
                <v-subheader v-bind:class="{ 'accent--text': isSelectedDayOfWeek(dayOfWeekGroup.dayOfWeek), 'font-weight-bold': isCurrentDayOfWeek(dayOfWeekGroup.dayOfWeek) || isSelectedDayOfWeek(dayOfWeekGroup.dayOfWeek) }">
                  {{ isCurrentDayOfWeek(dayOfWeekGroup.dayOfWeek) ? $t('today') : $t(daysOfWeekLabel(dayOfWeekGroup.dayOfWeek)) }}
                </v-subheader>
                <div class="pb-4 px-4">
                  <v-row align="center"
                        v-bind:key="timeSlot.id"
                        v-for="timeSlot in dayOfWeekGroup.timeSlots">
                    <v-col>
                      <strong>{{ timeSlot.from }}–{{ timeSlot.to }}</strong>
                    </v-col>
                    <v-col class="text-right">
                      <template v-if="timeSlot.comment != null && timeSlot.comment.length !== 0">
                        <strong>{{ timeSlot.comment }}</strong><br>
                      </template>
                      {{ timeSlot.streetAddress }}<br>
                      {{ timeSlot.postalCode }} {{ timeSlot.city }}<br>
                      {{ timeSlot.country }}
                    </v-col>
                    <v-col cols="auto">
                      <v-btn color="accent"
                             icon
                             v-bind:aria-label="$t('route')"
                             v-bind:href="mapUrl(timeSlot)">
                        <v-icon>mdi-directions</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <span class="closed--text"
                        v-if="dayOfWeekGroup.timeSlots.length === 0">
                    {{ $t('closed') }}
                  </span>
                </div>
                <v-divider />
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  import moment from 'moment'

  import settings from '../settings'

  import DialogHeader from '@/components/common/DialogHeader'
  import QuickAction from '@/components/common/QuickAction'

  export default {
    components: {
      DialogHeader,
      QuickAction
    },
    computed: {
      email() {
        if (!this.foodTruck.partner) {
          return 'anfragen@foodtrucksunited.de'
        }

        return this.foodTruck.email

        
      },
      canShare() {
        return navigator.share != null
      },
      description() {
        if (this.foodTruck?.description == null) {
          return ''
        }

        return this.foodTruck.description.replace(/\n/g, '<br>')
      },
      isEvenWeek() {
        return this.selectedWeek % 2 === 0
      },
      isOddWeek() {
        return this.selectedWeek % 2 === 1
      },
      slotDateLabel() {
        // Without a date selected on the map the slots shown are today's
        if (this.selectedDate == null || moment(this.selectedDate).isSame(moment(), 'day')) {
          return this.$t('today')
        }

        return this.$options.filters.formatDate(this.selectedDate, 'D.M.')
      },
      todaysSlots() {
        if (this.foodTruck?.timeSlots == null) {
          return []
        }

        const dayOfWeek = moment(this.selectedDate).isoWeekday()
        const week = moment(this.selectedDate).isoWeek()
        const isEvenWeek = week % 2 === 0
        const isOddWeek = week % 2 === 1

        const timeSlots = this.foodTruck.timeSlots.filter(t => !t.disabled && t.dayOfWeek === dayOfWeek && (t.evenWeeks && isEvenWeek || t.oddWeeks && isOddWeek))

        return timeSlots.sort((a, b) => a.from.localeCompare(b.from))
      },
      timeSlotGroups() {
        if (this.foodTruck?.timeSlots == null) {
          return []
        }

        return this.foodTruck.timeSlots.reduce((result, current) => {
          if (!(!current.disabled && current.evenWeeks && this.isEvenWeek || !current.disabled && current.oddWeeks && this.isOddWeek)) {
            return result
          }

          const index = result.findIndex(g => g.dayOfWeek === current.dayOfWeek)

          if (index !== -1) {
            result[index].timeSlots.push(current)

            result[index].timeSlots = result[index].timeSlots.sort((a, b) => a.from.localeCompare(b.from))
          }

          return result
        }, JSON.parse(JSON.stringify(this.timeSlotsDefault))).sort((a, b) => a.dayOfWeek - b.dayOfWeek)
      },
      weekItems() {
        return Array.from([0, 1], w => ({
          text: this.$t('cw', { week: moment().isoWeek() + w }),
          value: moment().isoWeek() + w
        }))
      },
      ...mapGetters({

        attachmentUrl: 'attachmentUrl',
        categoryIcon: 'categoryIcon',
        categoryTitle: 'categoryTitle',
        daysOfWeekLabel: 'daysOfWeekLabel'
      })
    },
    created() {
      this.selectedWeek = moment().isoWeek()
    },
    data: () => ({
      defaultImageUrl: `${process.env.BASE_URL}images/food-truck-default-image.jpg`,
      selectedWeek: null,
      tab: 'details',
      timeSlotsDefault: [
        {
          dayOfWeek: 1,
          timeSlots: []
        },
        {
          dayOfWeek: 2,
          timeSlots: []
        },
        {
          dayOfWeek: 3,
          timeSlots: []
        },
        {
          dayOfWeek: 4,
          timeSlots: []
        },
        {
          dayOfWeek: 5,
          timeSlots: []
        },
        {
          dayOfWeek: 6,
          timeSlots: []
        },
        {
          dayOfWeek: 7,
          timeSlots: []
        }
      ]
    }),
    methods: {
      isCurrentDayOfWeek(dayOfWeek) {
        if (this.selectedWeek != moment().isoWeek()) {
          return false
        }

        return moment().day() === dayOfWeek
      },
      isSelectedDayOfWeek(dayOfWeek) {
        if (this.selectedDate == null) {
          return false
        }

        if (this.selectedWeek != moment(this.selectedDate).isoWeek()) {
          return false
        }

        return moment(this.selectedDate).day() === dayOfWeek
      },
      mapUrl(timeSlot) {
        let baseUrl = 'http://maps.google.com/maps'

        if (navigator.platform.indexOf('iPad') != -1 ||
          navigator.platform.indexOf('iPhone') != -1 ||
          navigator.platform.indexOf('iPod') != -1 ||
          navigator.platform.indexOf('Mac') != -1) {
          baseUrl = 'maps://maps.google.com/maps'
        }

        return `${baseUrl}?daddr=${timeSlot.latitude},${timeSlot.longitude}&amp;ll=`
      },
      async open() {
        if (this.selectedDate != null) {
          this.selectedWeek = moment(this.selectedDate).isoWeek()
        }

        this.$emit('input', true)
      },
      async share() {
        await navigator.share({
          title: this.foodTruck.title,
          text: this.foodTruck.description,
          url: `${settings.baseUrl}/?foodTruckId=${this.foodTruck.id}`,
        })
      }
    },
    name: 'FoodTruckDialog',
    props: {
      foodTruck: Object,
      selectedDate: String,
      value: Boolean
    },
    watch: {
      foodTruck(newValue) {
        // Partners have no hours tab, so never leave them on it
        if (newValue?.partner) {
          this.tab = 'details'
        }
      }
    }
  }
</script>

<style scoped>
  /* The day selected on the map: subtle tint and an accent edge instead of a solid block */
  .hours-day--selected {
    background: var(--v-accent-lighten5);
    box-shadow: inset 3px 0 0 var(--v-accent-base);
  }
</style>

<i18n>
  {
    "de": {
      "catering": "Catering",
      "close": "Schließen",
      "contact": "Kontakt",
      "closed": "Geschlossen",
      "cw": "KW {week}",
      "details": "Details",
      "goToWebSite": "Zur Website",
      "hours": "Öffnungszeiten",
      "instagram": "Instagram",
      "location": "Adresse",
      "onlineShop": "Kooperationsinfo",
      "order": "Bestellen",
      "phone": "Telefon",
      "route": "Route",
      "share": "Teilen",
      "showMenu": "Speisekarte anzeigen",
      "specialties": "Special Facts",
      "today": "Heute"
    },
    "en": {
      "catering": "Catering",
      "close": "Close",
      "contact": "Contact",
      "closed": "Closed",
      "cw": "CW {week}",
      "details": "Details",
      "goToWebSite": "Go to website",
      "hours": "Hours",
      "instagram": "Instagram",
      "location": "Location",
      "onlineShop": "Cooperations",
      "order": "Order",
      "phone": "Phone",
      "route": "Directions",
      "share": "Share",
      "showMenu": "Show menu",
      "specialties": "Specialties",
      "today": "Today"
    }
  }
</i18n>